//Auth
export const API_AUTH_LOGIN = '/auth/signin';

//Users
export const API_GET_ALL_USERS = '/users';
export const API_USERS_TOKEN = '/users/token';
export const API_GET_ALL_ROLE = '/users/role?system=' + process.env.REACT_APP_LOCALHOST_SYSTEM;
//Match
export const API_MATCH = '/match';

export const API_MATCH_WC_MATCHES = '/match/wc-matches';
export const API_MATCH_UPCOMING_SCHEDULE = '/match/upcoming-schedule';
export const API_MATCH_RESULT = '/match/update-matches';

//Predictions
export const API_PREDICTIONS = '/predictions';

// World Cup 2026
export const API_TEAM_PREDICTIONS = '/worldcup/get-team-predictions';
export const API_PLAYER_PREDICTIONS = '/worldcup/get-player-predictions';
export const API_GET_WORLDCUP_RESULTS = '/worldcup/get-worldcup-results';
export const API_UPDATE_WORLDCUP_RESULT = '/worldcup/update-worldcup-result';
export const API_TEAMS = '/teams';
export const API_PLAYERS = '/players';

//Settings
export const API_SETTINGS = '/settings';
export const API_SETTINGS_RANK = '/settings/update-rank';
export const API_SETTINGS_PRIZE_STRUCTURE = '/settings/update-prize-structure';
//Banner
export const API_BANNER = '/banner';
//Uploads
export const API_UPLOAD_IMAGE = '/upload/image';

// LiveScore APIs
export const API_GET_ALL_LEAGUE = '/get-league';
export const API_GET_MATCH_SCHEDULE = '/match-schedule';
export const API_GET_SCHEDULE_BY_LEAGUE = '/get-schedule';

//Lottery - Fix API paths to match backend exactly
export const API_LOTTERY = '/lottery'; // Add back /api prefix
export const API_LOTTERY_RESULT = '/lottery/update-lottery-result'; // Fix to match backend route
export const API_LOTTERY_RESULTS = '/lottery/results'; // Add new endpoint for getting results

//Lottery Prediction
export const API_LOTTERY_PREDICTION = '/lottery-predict/admin';
export const API_LOTTERY_PREDICTION_REPORT = '/lottery-predict/admin/report';

export const API_SETTINGS_LOTTERY_REWARD = '/settings/lottery-reward';
